import styled from 'styled-components';

import { Spinner } from 'components/ui';
import { Theme } from 'utils/color/horizonTheme';

interface StyledCommentsProps {
  $columnLayout?: boolean;
  $isAtTop?: boolean;
  $maxHeight?: string;
}

export const StyledCommentsWrapper = styled.div<StyledCommentsProps>`
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  display: ${({ $columnLayout }) => $columnLayout && 'flex'};

  .ant-comment-content-author-name {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;

    .comment-author-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${({ theme }) => (theme.themeName === Theme.Dark ? theme.labelColor : 'unset')};
    }

    .ant-tag {
      flex-shrink: 0;
      margin: 0;
    }
  }

  .ant-comment-actions {
    margin: 0.5rem 0 0 0;
  }

  .ant-comment-inner {
    padding: 0.5rem 0;
  }

  .ant-comment-content-detail {
    white-space: break-spaces;
    color: ${({ theme }) => (theme.themeName === Theme.Dark ? theme.textColor : 'unset')};
  }

  // to fix the styling in Firefox as a result of the white-space property
  .ant-row::before,
  .ant-row::after,
  .ant-legacy-form-item-control::before,
  .ant-legacy-form-item-control::after {
    display: unset;
    content: unset;
  }

  ${({ $isAtTop, theme }) =>
    !$isAtTop &&
    `
    &:before {
      content: '';
      position: absolute;
      top: -10px;
      left: 0;
      right: 0;
      height: 10px;
      box-shadow: 0px 5px 5px -3px ${theme.lightShadow};
      z-index: 1;
    }
  `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    `
      [data-testid='comments'] {
        overflow-y: auto;
        max-height: ${$maxHeight};
      }

      .ant-comment-inner {
        padding-bottom: 0;
      }

      .ant-comment-content-detail {
        .ant-form-item:nth-child(2) {
          margin-bottom: 0;
        }
      }
  `}
`;

export const StyledSpinner = styled(Spinner)`
  min-height: unset;
`;
